import type { DomainEventScope } from "@/stores/useDomainEventStore";

/**
 * Maps a lineage edge target to the domain-event scope key subscribers watch.
 */
export function domainScopeForLineage(
  projectId: string,
  targetType: string,
  targetPublicId: string,
): DomainEventScope {
  if (targetType === "conversation") {
    return { projectId, conversationId: targetPublicId };
  }
  return { projectId, conversationId: null };
}
